import React, { useState } from 'react';
import './GantiPasswordModal.css';

const GantiPasswordModal = ({ isOpen, onClose, userName, api }) => {
  const [passwordLama, setPasswordLama] = useState('');
  const [passwordBaru, setPasswordBaru] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!passwordLama || !passwordBaru || !rePassword) {
      setError('Semua field harus diisi');
      return;
    }

    if (passwordBaru !== rePassword) {
      setError('Password baru tidak cocok');
      return;
    }

    setLoading(true);
    try {
      const dataUser = localStorage.getItem('pengguna');
      if (!dataUser) {
        setError('Data user tidak ditemukan');
        setLoading(false);
        return;
      }
      const parsed = JSON.parse(dataUser);

      // endpoint sesuai backend
      const response = await api.post('/api/users/change-password', {
        kode: parsed.kode,
        passwordLama,
        passwordBaru
      });

      setSuccess(response.data?.message || 'Password berhasil diubah');
      setTimeout(() => {
        resetForm();
        onClose();
      }, 1200);
    } catch (err) {
      console.error('Ganti password error:', err);
      if (err.response?.status === 401) setError('Password lama salah');
      else if (err.response?.data?.message) setError(err.response.data.message);
      else setError('Gagal mengubah password');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setPasswordLama('');
    setPasswordBaru('');
    setRePassword('');
    setError('');
    setSuccess('');
  };

  const handleCancel = () => {
    resetForm();
    if (typeof onClose === 'function') onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="gpm-overlay">
      <div className="gpm-content">
        <div className="gpm-header">
          <h2>GANTI PASSWORD</h2>
          <button className="gpm-close-btn" onClick={handleCancel}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="gpm-form-group">
            <label>USER</label>
            <input
              type="text"
              value={userName}
              disabled
              className="gpm-form-control"
            />
          </div>

          <div className="gpm-form-group">
            <label>PASSWORD LAMA</label>
            <input
              type="password"
              value={passwordLama}
              onChange={(e) => setPasswordLama(e.target.value)}
              placeholder="Masukkan password lama"
              className="gpm-form-control"
            />
          </div>

          <div className="gpm-form-group">
            <label>PASSWORD BARU</label>
            <input
              type="password"
              value={passwordBaru}
              onChange={(e) => setPasswordBaru(e.target.value)}
              placeholder="Masukkan password baru"
              className="gpm-form-control"
            />
          </div>

          <div className="gpm-form-group">
            <label>RE PASSWORD</label>
            <input
              type="password"
              value={rePassword}
              onChange={(e) => setRePassword(e.target.value)}
              placeholder="Konfirmasi password baru"
              className="gpm-form-control"
            />
          </div>

          {error && <div className="gpm-alert gpm-alert-danger">{error}</div>}
          {success && <div className="gpm-alert gpm-alert-success">{success}</div>}

          <div className="gpm-form-actions">
            <button type="button" onClick={handleCancel} className="gpm-btn gpm-btn-secondary">Cancel</button>
            <button type="submit" disabled={loading} className="gpm-btn gpm-btn-success">
              {loading ? 'Loading...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GantiPasswordModal;